module.exports = __webpack_public_path__ + "static/media/icon-create-group.62e0cd8d.svg";